module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAABRElEQVQYGQXBTYtNcQAH4Oec879zx8Q1o85thrGYa6NkFpMiCyVsKClfYHbsLeyUUppkR8nC28pGWFgoH0ApSvkEwpBSmo3OvefneQAAAAAAAMj+3MqXXMsSAFAAUll1xXFvXVLnafULAECarOdBXuRiFnM5r3M7k9QAIPO5kJd5khMppORkHuZxTmUOQNpczfvcy6HUQOpMcjfvsplFQO7kU25mBQDIcm7kY65nRMHYc8+qHwBAtZ1Heq15fwu2nDHJ76qDNFojlQXnLXhjSMGOo74BaN23plPsMXXOjtMFc4ZqACOHvfJVMdNZs0kBAUBvYMOqBjNjuygAAoip77YVTE11FFTolUAUVABAQa+34qwKnQN2G2s0mBkbUPDHZxuOCXr7FB/8NEDnoHUqUttrSSNg2ZZWp0Zv6F91BAAAAAD8ByNMfsl9qt9mAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/lsNavIcon/kcIcon.png
// module id = pTET
// module chunks = 95